import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (hash) {
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (target) {
        target.scrollIntoView();
        return;
      }
    }

    const { style } = document.documentElement;
    const previous = style.scrollBehavior;
    style.scrollBehavior = "auto";
    window.scrollTo(0, 0);
    style.scrollBehavior = previous;
  }, [pathname, hash]);

  return null;
};
